import React from 'react';
import styled from 'styled-components';
import { IconChevronDown, IconSearch } from 'wg-fe-ui';
import { mq } from '../utils/styledComponentsUtils';
import { isMobile as isMobileDevice } from 'react-device-detect';
import { useBreakpointValue } from '@wegroup/design-system';

interface Props {
  innerProps: Record<string, unknown>;
  innerRef: React.RefObject<HTMLDivElement>;
  children: Node | React.ReactNode;
  selectProps: {
    menuIsOpen: boolean;
    innerProps: {
      showSearchIcon: boolean;
    };
  };
  data: {
    label_secondary?: string;
    label: string;
    value: string | number;
  };
}

const SearchSelectCustomDropdownIndicator: React.FC<
  React.PropsWithChildren<Props>
> = ({ innerProps, innerRef, selectProps }) => {
  const isMobileBreakpoint = !!useBreakpointValue({
    base: true,
    laptop: false,
  });
  const isMobile = isMobileDevice || isMobileBreakpoint;
  const { showSearchIcon } = selectProps.innerProps;
  return (
    <div {...innerProps} ref={innerRef} className="Select__dropdown-indicator">
      <IconContainer
        isMobile={isMobile || showSearchIcon}
        open={selectProps?.menuIsOpen}
      >
        {isMobile || showSearchIcon ? (
          <IconSearch color="#C1C1C1" />
        ) : (
          <IconChevronDown color="#C1C1C1" />
        )}
      </IconContainer>
    </div>
  );
};

const IconContainer = styled.div<{ open: boolean; isMobile: boolean }>`
  padding-right: 0.4rem;
  display: flex;
  align-items: center;
  height: 100%;
  & svg {
    transition: 0.2s;
    opacity: 0.5;
    width: 3.5rem;

    ${mq.laptop} {
      transform: ${({ open, isMobile }) =>
        open && !isMobile ? 'rotate(180deg)' : null};
    }
  }
`;

export default SearchSelectCustomDropdownIndicator;
